/* eslint-disable react/prop-types */
/**
 * BookingsProvider
 * Contain most logic handing with Omnitech Api
 */
import React from 'react'
import _ from 'lodash'
import { getAllDataInParallel } from '../../helpers'
import BookingsContext from './bookings-context'
import { createBookingCancel, fetchBookings, fetchBooking } from './bookings-api'

export default function BookingsProvider({ children }) {

  function fetchBookingsAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchBookings({
        ...params,
        ...args,
      }),
      key: 'consumedSkuQuotas',
    })
  }

  const state = {
    createBookingCancel,
    fetchBookings,
    fetchBookingsAll,
    fetchBooking,
  }

  return (
    <BookingsContext.Provider value={state}>
      {children}
    </BookingsContext.Provider>
  )
}
